"use client"

import React from "react"
import UnifiedLayout from "./ui/dashboard/UnifiedLayout"
import Sidebar from "./Sidebar"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth()
  const { t } = useLanguage()

  return (
    <UnifiedLayout
      sidebar={<Sidebar />}
      user={user}
      onLogout={logout}
      title={t("adminDashboard")}
      subtitle={t("manageDeliveryPlatform")}
    >
      {children}
    </UnifiedLayout>
  )
}

export default Layout
